/**
 * @fileoverview Zod schemas for the Archive and Restore Prospect dialogs.
 * @description Archiving (dropping) a prospect needs a reason of 1 to 500 characters; restoring one
 * takes an optional note of at most 500. Messages are translation keys, translated at the display
 * call site in ProspectArchiveDialog.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { z } from 'zod'

/** @description The longest reason or note the backend accepts. */
export const ARCHIVE_NOTE_MAX_LENGTH = 500

/** @description The archive form's rules: a mandatory reason. */
export const archiveProspectFormSchema = z.object({
  reasonNote: z
    .string()
    .trim()
    .min(1, 'sales.pipeline.archive.errors.reasonRequired')
    .max(ARCHIVE_NOTE_MAX_LENGTH, 'sales.pipeline.archive.errors.reasonTooLong'),
})

/** @description The restore form's rules: an optional note. */
export const restoreProspectFormSchema = z.object({
  reasonNote: z
    .string()
    .trim()
    .max(ARCHIVE_NOTE_MAX_LENGTH, 'sales.pipeline.restore.errors.noteTooLong'),
})

/** @description Both forms' values. */
export type ProspectArchiveFormValues = z.infer<typeof archiveProspectFormSchema>
